import React from "react";
import { Autocomplete, TextField, Popper } from "@mui/material";
import Stack from "@mui/material/Stack";
import { makeStyles, styled } from "@mui/styles";

const useStyles = makeStyles({
  customAutocomplete: {
    // Label color in default
    width: 250,

    "& .MuiFormLabel-root": {
      color: "#6c757d",
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: "0.5px",
      fontFamily: "Roboto",
    },

    // Label size & color when focused
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#012970",
      fontSize: 14,
    },

    // Adjusting input field height and padding
    "& .MuiOutlinedInput-root": {
      height: 35, // Set the height of the input field
      //   padding: "0px 10px",
      fontSize: 12, // Adjust font size for smaller input
    },

    // Border color in default
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#adb5bd",
    },

    // Border color when focused
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#012970",
    },

    // Down arrow color in default
    "& .MuiSvgIcon-root": {
      color: "#6c757d",
      marginTop: "auto", // Align it vertically
      marginBottom: "auto",
    },

    // Font size and color while typing in Autocomplete
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      color: "#282829",
      fontSize: 12,
      fontWeight: "600",
      fontFamily: "'Roboto', sans-serif",
    },

    // Label size -> after selected the value and moved to next field
    "& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink.MuiFormLabel-filled":
      {
        fontSize: 15,
      },

    // Hide close icon
    "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  },
  listbox: {
    maxHeight: "200px",
    overflow: "auto",
    scrollbarWidth: "thin",
    backgroundColor: "#ffffff",
    borderRadius: "5px",
    color: "#282829",
    fontSize: 12,
    fontWeight: "bold",
    fontFamily: "'Roboto', sans-serif",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  },
  option: {
    "&[aria-selected='true']": {
      backgroundColor: "#e0f7fa",
    },
    "&:hover": {
      backgroundColor: "#81cafd !important",
    },
  },
});

export default function MuiAutoComplete({
  id,
  options = [],
  getOptionLabel,
  onChange,
  isOptionEqualToValue,
  textFieldLabel,
  ...other
}) {
  const classes = useStyles();
  return (
    <Autocomplete
      classes={{
        root: classes.customAutocomplete,
        listbox: classes.listbox,
        option: classes.option,
      }}
      id={id}
      options={options}
      getOptionLabel={getOptionLabel}
      onChange={onChange}
      isOptionEqualToValue={isOptionEqualToValue}
      renderInput={(params) => (
        <TextField
          {...params}
          label={textFieldLabel}
          variant="outlined"
          size="small"
          {...other}
        />
      )}
      {...other}
    />
  );
}
